import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { commonService } from "../services";

const initialState = {
  logo: null,
  status: "idle",
  error: null
};

export const refreshLogo = createAsyncThunk("logo/refreshLogo", async () => {
  const res = await commonService.getLogo();
  return res.data;
});

const logoSlice = createSlice({
  name: "logo",
  initialState,
  reducers: {
    clearLogo: state => {
      state.logo = {};
    }
  },
  extraReducers: {
    [refreshLogo.pending]: (state, action) => {
      state.status = "loading";
    },
    [refreshLogo.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.logo = action.payload;
    },
    [refreshLogo.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    }
  }
});

export const { clearLogo } = logoSlice.actions;

export const selectLogo = (state) => state.logo.logo;

export default logoSlice.reducer;
